export enum UploadDocumentType {
  UploadCustomerAgreement = 'uploadCustomerAgreement',
  UploadIdDocuments = 'uploadIdDocuments',
}
